import { cx } from '@emotion/css'
import React from 'react'
import { AccessibleText } from '@offerzen/pinata'
import PropTypes from 'prop-types'
import SectionHeading from '../SectionHeading'
import styles, { highlightTheme } from './styles'

const Roles = ({ className, roles, theme, filteredRoles }) => {
  const rolesCount = roles.length
  const maxNumOfRolesDisplayed = 3
  const hasMoreRolesThanMaxDisplayed = rolesCount > maxNumOfRolesDisplayed

  const rolesWithFilter = roles.map(role => {
    const minExperience = role.experience.min
    const maxExperience = role.experience.max ? `-${role.experience.max}` : ''

    return {
      ...role,
      displayedExperience: `${minExperience}${maxExperience}`,
      matchesFilter: filteredRoles?.some(filterRole => filterRole.label === role.title),
    }
  })

  // Instead of calculating the percentage for every role experience, the values are set in this object because these remain constant.
  const experiencePercentOfBar = {
    '0-1': 6,
    '1-2': 11,
    '2-4': 22,
    '4-6': 33,
    '6-10': 56,
    '10-15': 83,
    '15+': 100,
  }

  return (
    <If condition={roles.length}>
      <div className={className}>
        <SectionHeading
          title="Roles and experience"
          count={rolesCount}
          countDisplayed={hasMoreRolesThanMaxDisplayed ? maxNumOfRolesDisplayed : rolesCount}
        />

        <div className={styles.list}>
          {rolesWithFilter.slice(0, maxNumOfRolesDisplayed).map(role => (
            <li className={styles.roleItem} key={`${role.title} ${role.experience}`}>
              <div className={styles.role}>{role.title}</div>
              <AccessibleText className={styles.experience} displayText={`${role.displayedExperience} yrs`} />
              <div className={cx(styles.progress, role.matchesFilter && highlightTheme())}>
                <div
                  style={{
                    width: `${experiencePercentOfBar[role.displayedExperience]}%`,
                  }}
                />
              </div>
            </li>
          ))}
        </div>
      </div>
    </If>
  )
}

Roles.propTypes = {
  className: PropTypes.string,
  theme: PropTypes.string,
  roles: PropTypes.arrayOf(PropTypes.shape({})),
  filteredRoles: PropTypes.array,
}

export default Roles
